import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { ListItemNode, ListNode } from '@lexical/list';
import { CodeHighlightNode, CodeNode } from '@lexical/code';
import { LinkNode, AutoLinkNode } from '@lexical/link';
import { TableNode, TableCellNode, TableRowNode } from '@lexical/table';
import { SuggestionNode } from '../nodes/SuggestionNode';
import { InlineSuggestionNode } from '../nodes/InlineSuggestionNode';
import { HtmlNode } from '../nodes/HtmlNode';

export default [
  HeadingNode,
  QuoteNode,
  ListNode,
  ListItemNode,
  CodeNode,
  CodeHighlightNode,
  LinkNode,
  AutoLinkNode,
  TableNode,
  TableCellNode,
  TableRowNode,
  SuggestionNode,
  InlineSuggestionNode,
  HtmlNode,
];
